<template>
  <div class="sc-user-input--menu">
    <button
      @click="toggleMenu"
      type="button"
      id="sc-menu-button"
      class="sc-user-input--menu-button"
    >
      <svg
        class="sc-user-input--menu-img"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        enableBackground="new 0 0 32 32"
      >
        <path
          d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2
            s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z
            M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2
            S29.104,22,28,22z"
        />
      </svg>
    </button>
    <transition name="fade">
    <div
      tabIndex="0"
      @blur="blur"
      ref="menu"
      class="sc-menu-content"
      v-show="displayMenu"
      :style="{ color: colors.header.text, backgroundColor: colors.header.bg }"
    >
      <div class="sc-header-submenu-content">
        <a
          :style="{ color: colors.header.text}"
          class="sc-return-submenu-content"
          v-if="current._parent"
          @click.prevent="previous(current)"
          >&#8249;</a
        >
        <h4 class="sc-title-submenu-title">{{ current.title }}</h4>
      </div>
      <div
        class="sc-menu-elements"
        :style="{ color: colors.header.text }"
        v-if="current.call_to_actions"
      >
        <menu-item
          v-for="(subitem, index) in current.call_to_actions"
          :key="index"
          :item="subitem"
          :parent="current"
          @openSubItems="openSubItems"
          @postback="handlePostback"
        />
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import MenuItem from '../MenuItem.vue'
export default {
  name: 'MenuIcon',
  inject: {
    chat: {
      type: Object
    },
    settings: {
      type: Object
    },
    colors: {
      type: Object
    }
  },
  components: {
    MenuItem
  },
  computed: {
    menuTree() {
      return {
        title: 'Menu',
        type: 'nested',
        call_to_actions: this.settings.menu
      }
    }
  },
  data () {
    return {
      displayMenu: false,
      current: {}
    }
  },
  mounted() {
    this.current = this.menuTree
  },
  methods: {
    toggleMenu() {
      if (!this.displayMenu) {
        this.displayMenu = true
        this.$nextTick(() => { this.$refs.menu.focus() })
      } else {
        this.displayMenu = false
      }
    },
    blur(e) {
      (!e.relatedTarget || e.relatedTarget.id !== "sc-menu-button") && (this.toggleMenu())
    },
    openSubItems(item) {
      this.current = item
    },
    handlePostback(item) {
      this.chat.payload = item
      this.chat.send = {
        event,
        source: "persistent-menu",
        data: {
          type: "postback",
          data: item
        }
      }
      this.settings.autoFlush && (this.chat.payload = null);
      this.$refs.menu.blur()
    },
    previous(current) {
      this.current = current._parent
    }
  }
}
</script>

<style scoped>
.sc-user-input--menu {
  align-self: center;
}
.sc-user-input--menu-button {
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.sc-user-input--menu-img {
  max-width: 24px;
}
.sc-menu-content {
  display: block;
  position: absolute;
  box-shadow: 0px -10px 20px 5px rgba(150, 165, 190, 0.2);
  width: 60%;
  bottom: 55px;
  z-index: 1;
}

.sc-menu-content:active,
.sc-menu-content:focus {
  outline: none;
}

.sc-header-submenu-content {
  position: relative;
  text-align: center;
}

.sc-title-submenu-title {
  padding: .5rem;
  font-weight: 600;
  font-size: 1.25rem;
}

.sc-return-submenu-content {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.75rem;
  padding: 1rem;
  text-decoration: none;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transform: translate(0%, 0%);
  transition: all 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate(-5%, 5%) scale(0.9);
}
</style>
